import TurfEllipse from '@turf/ellipse';
import PolySmooth from '@turf/polygon-smooth';

import {polygon, featureCollection} from '@turf/helpers';

class LayerEllipses {
	

	
	constructor(context) {
		
		this.scenario = context.tc.scenario;
		this.map = context.tc.draw.map;
		this.du = context.tc.draw;
		this.tc = context.tc;
		this.context = context;
		//this.placeBoundaries();
		
	}
	
	json () {
		
		const turbines				= this.tc.scenario.wtgs;
		
		
		const l = {
			source: {
				'type': 'geojson',
				'data': {
					"type":"FeatureCollection",
					"features":[]
				},
				'id': LayerEllipses.sourceId
			}
		};
		
		turbines.forEach((turbine)=>{
			//check if turbine was deleted
			if(!turbine.geometry)
				return;
			
			//this.ellipses.push(turbine.turbineid);
			var ellipse_geometry = this.generateEllipse(turbine.geometry.coordinates);
			ellipse_geometry.features[0].properties.turbineid = turbine.turbineid
			
			l.source.data.features.push(ellipse_geometry.features[0]);
			
		});	


		// Add a new layer to visualize the polygon.
		l.layer = [{
			'id': LayerEllipses.layerId,
			'type': 'line',
			'source': LayerEllipses.sourceId, // reference the data source
			'paint': {
				'line-color': LayerEllipses.defaultColor,
				'line-width': LayerEllipses.defaultWidth
			}
		}]
		LayerEllipses.data = l.source.data;
		return l;
	}

	generateEllipse(center, project) { //radius in meters
		
		
		const p = this.context.getters.project;
		var s = {};
		
		if(!this.tc.scenario.wtgSettings.windEllipse){
		
			var longRadius = p.long_turbine_radius; // radius in meters
			var shortRadius = p.short_turbine_radius;
		}
		else {

			s = this.tc.scenario.wtgSettings.windEllipse.custom;
			const turbine = this.tc.scenario.turbine_types.find((a)=>{return a.turbine_type == this.tc.scenario.wtgSettings.turbineType});


			var longRadius = (turbine.rotor_diameter/2) * s.majorAxis; // radius in meters
			var shortRadius = (turbine.rotor_diameter/2) * s.minorAxis; // radius in meters
			
		}
		
		//i am adding 90 degrees to the orientation, TurfEllipse with 0 degrees, creates a ellipse in "landscape" orientation
		return PolySmooth(TurfEllipse(center, longRadius, shortRadius, {steps:128, units:'meters', angle:(s.direction ?? s.orientation ?? p.wind_direction)+90}), {});
	};
}

LayerEllipses.layerId			= 'ellipses';
LayerEllipses.sourceId			= 'ellipses_source';
LayerEllipses.defaultWidth		= 2;
LayerEllipses.defaultColor		= "#D92D20";
LayerEllipses.layers			= [
	{id: LayerEllipses.layerId },
]


export default LayerEllipses;